// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3p0NR","title":"AfterBackImages_title__2gLfS","images":"AfterBackImages_images__2VDae"};